import type { Theme } from "@mui/material/styles"

import { isUsableColor, normalizeHexColor } from "../../../lib/colorLib"

// Material 3 pair kept verbatim, no tailwind token equivalent
const FALLBACK_BG_COLOR = "#eaddff"
const FALLBACK_COLOR = "#21005e"

export const resolveEventColors = (
    theme: Theme,
    apiColor: string | undefined,
    apiBgColor: string | undefined,
): { color: string; bgColor: string } => {
    const rawColor = apiColor?.trim()
    const rawBackground = apiBgColor?.trim()

    // the pair goes through untouched, in whatever CSS format the backend sends it
    if (rawBackground && rawColor) {
        return { bgColor: rawBackground, color: rawColor }
    }

    // a single colour fills the event, so the text has to be derived - and getContrastText
    // only survives values it can parse
    const background = normalizeHexColor(rawBackground)
    if (isUsableColor(background)) {
        return { bgColor: background, color: theme.palette.getContrastText(background) }
    }

    const color = normalizeHexColor(rawColor)
    if (isUsableColor(color)) {
        return { bgColor: color, color: theme.palette.getContrastText(color) }
    }

    return { bgColor: FALLBACK_BG_COLOR, color: FALLBACK_COLOR }
}
